"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.object.entries.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.string.starts-with.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _head = _interopRequireDefault(require("next/head"));

var _script = _interopRequireDefault(require("next/script"));

var _cookies = _interopRequireDefault(require("@meepshop/cookies"));

var _link = require("@meepshop/link");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// definition
var ROUTES_REDIRECTED_AFTER_LOGIN = ['/', '/cart'];

var isGA4 = function isGA4(id) {
  return id.startsWith('G-');
};

var buildUserProperties = function buildUserProperties(userId, memberGroup, segmentationTagCode) {
  var properties = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, userId && {
    user_id: userId
  }), (memberGroup === null || memberGroup === void 0 ? void 0 : memberGroup.id) && {
    member_group_id: memberGroup.id
  }), (memberGroup === null || memberGroup === void 0 ? void 0 : memberGroup.name) && {
    member_group_name: memberGroup.name
  }), segmentationTagCode && {
    segmentation_tag_code: segmentationTagCode
  });

  if (Object.keys(properties).length === 0) return '';
  var propertiesString = Object.entries(properties).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "".concat(key, ": '").concat(value, "'");
  }).join(', ');
  return "gtag('set','user_properties',{ ".concat(propertiesString, " });");
};

var _default = /*#__PURE__*/_react["default"].memo(function (_ref3) {
  var user = _ref3.user,
      store = _ref3.store,
      fbq = _ref3.fbq;
  var userId = user.id,
      email = user.email,
      name = user.name,
      mobile = user.mobile,
      role = user.role,
      memberGroup = user.memberGroup,
      segmentationTagCode = user.segmentationTagCode;
  var isLoggedIn = role === 'SHOPPER';

  var _useContext = (0, _react.useContext)(_cookies["default"]),
      cookies = _useContext.cookies;

  var router = (0, _link.useRouter)();
  var prevHrefRef = (0, _react.useRef)('');
  var isInitialRenderDone = (0, _react.useRef)(false);
  var _store$adTracks = store.adTracks,
      googleSearchConsoleVerificationHtml = _store$adTracks.googleSearchConsoleVerificationHtml,
      googleMerchantCenterVerificationCode = _store$adTracks.googleMerchantCenterVerificationCode,
      facebookPixelId = _store$adTracks.facebookPixelId,
      googleAnalyticsId = _store$adTracks.googleAnalyticsId,
      googleAdwordsConfig = _store$adTracks.googleAdwordsConfig,
      googleTagManager = _store$adTracks.googleTagManager;
  var googleAnalyticsConfigScriptHTML = (0, _react.useMemo)(function () {
    return " window.dataLayer = window.dataLayer || [];\n      function gtag(){dataLayer.push(arguments);}\n      gtag('js', new Date());\n      ".concat(googleAnalyticsId ? //  GA4 - Cross Device - User ID
    "gtag('config', '".concat(googleAnalyticsId, "', {\n              page_path: '").concat(router.asPath, "'\n              ").concat(isGA4(googleAnalyticsId) ? ",cookie_prefix: 'MEEPSHOP',\n                      cookie_domain: '".concat(router.domain, "'\n                      ").concat(userId ? ", user_id: '".concat(userId, "' ") : '') : '', "\n        });") : '', "\n      \n      ").concat(googleAnalyticsId && userId && !isGA4(googleAnalyticsId) ? //  GA - Cross Device - User ID
    "gtag('set', { user_id: '".concat(userId, "'});") : '', "\n      ").concat(googleAnalyticsId ? buildUserProperties(userId, memberGroup, segmentationTagCode) : '', "\n\n    ");
  }, [googleAnalyticsId, router.asPath, router.domain, userId, memberGroup, segmentationTagCode]); // 如果不加 disablePushState，在 client 模式下的 navigate 會導致 fbq 自動觸發 PageView 無法帶上 eventID
  // 但是加了 disablePushState 之後，還要加 allowDuplicatePageViews 才能在 client 模式下自己觸發 PageView 並自己帶上 eventID
  // ref: https://github.com/zsajjad/react-facebook-pixel/issues/82

  var facebookPixelScriptHTML = (0, _react.useMemo)(function () {
    return "\n  !function(f,b,e,v,n,t,s)\n  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n  n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n  n.queue=[];t=b.createElement(e);t.async=!0;\n  t.src=v;s=b.getElementsByTagName(e)[0];\n  s.parentNode.insertBefore(t,s)}(window, document,'script',\n  'https://connect.facebook.net/en_US/fbevents.js');\n      fbq.disablePushState = true;\n      fbq.allowDuplicatePageViews = true\n      fbq('init', '".concat(facebookPixelId, "', {\n        ").concat(isLoggedIn ? "external_id: '".concat(cookies.identity, "',\n                em: '").concat(email, "'") : '', "\n      }, { agent: 'plmeepShop' });\n    ");
  }, [cookies.identity, email, facebookPixelId, isLoggedIn]); // Since Next.js will not update Script on page navigation , userId will not be included in the script
  // The following could be removed once the issue is fixed: https://github.com/vercel/next.js/discussions/17346#discussioncomment-84584

  (0, _react.useEffect)(function () {
    // Script Update is not required when user logs out
    // Update Google Analytics Config Script
    var isGAConfigScriptUpdateRequired = isInitialRenderDone.current && ROUTES_REDIRECTED_AFTER_LOGIN.includes(router.asPath) && userId;

    if (isGAConfigScriptUpdateRequired) {
      var newScript = document.createElement('script');
      var oldScript = document.getElementById('google-analytics-config');
      newScript.type = 'text/javascript';
      newScript.id = 'google-analytics-config';
      newScript.text = googleAnalyticsConfigScriptHTML;

      if (oldScript) {
        oldScript.remove();
      }

      document.body.appendChild(newScript);
    } // Update Facebook Pixel Script


    var newFbPixelScript = document.createElement('script');
    var oldFbPixelScript = document.getElementById('facebook-pixel-config');
    newFbPixelScript.type = 'text/javascript';
    newFbPixelScript.id = 'facebook-pixel-config';
    newFbPixelScript.text = facebookPixelScriptHTML;

    if (oldFbPixelScript) {
      oldFbPixelScript.remove();
    }

    document.body.appendChild(newFbPixelScript);
    isInitialRenderDone.current = true;
  }, [googleAnalyticsConfigScriptHTML, facebookPixelScriptHTML, router.asPath, userId]);
  (0, _react.useEffect)(function () {
    if (router.asPath !== prevHrefRef.current) {
      prevHrefRef.current = router.asPath;
      fbq('track', 'PageView');
    }
  }, [fbq, router.asPath]);
  (0, _react.useEffect)(function () {
    if (isLoggedIn && window.gtag) {
      window.gtag('set', 'user_data', _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, userId ? {
        id: userId
      } : {}), name ? {
        name: name
      } : {}), email ? {
        email: email
      } : {}), mobile ? {
        phone_number: mobile
      } : {}));
    }
  }, [email, isLoggedIn, mobile, name, userId]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_head["default"], null, !googleSearchConsoleVerificationHtml ? null : /*#__PURE__*/_react["default"].createElement("meta", {
    content: googleSearchConsoleVerificationHtml,
    name: "google-site-verification"
  }), !googleMerchantCenterVerificationCode ? null : /*#__PURE__*/_react["default"].createElement("meta", {
    content: googleMerchantCenterVerificationCode,
    name: "google-site-verification"
  })), facebookPixelId ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_script["default"], {
    id: "facebook-pixel-config",
    dangerouslySetInnerHTML: {
      __html: facebookPixelScriptHTML
    }
  }), /*#__PURE__*/_react["default"].createElement(_script["default"], {
    id: "facebook-pixel-js",
    strategy: "lazyOnload",
    src: "https://connect.facebook.net/en_US/fbevents.js"
  }), /*#__PURE__*/_react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("noscript", {
    dangerouslySetInnerHTML: {
      __html: "\n                    <img\n                      src=\"https://www.facebook.com/tr?id=".concat(facebookPixelId, "&ev=PageView&noscript=1\"\n                      height=\"1\"\n                      width=\"1\"\n                      style=\"display:none\"\n                    />\n                  ")
    }
  }))) : null, googleAnalyticsId ? /*#__PURE__*/_react["default"].createElement(_script["default"], {
    id: "google-analytics-js",
    strategy: "lazyOnload",
    src: "https://www.googletagmanager.com/gtag/js?id=".concat(googleAnalyticsId)
  }) : null, googleAdwordsConfig ? /*#__PURE__*/_react["default"].createElement(_script["default"], {
    id: "google-adwords-config",
    src: "https://www.googletagmanager.com/gtag/js?id=".concat(googleAdwordsConfig),
    dangerouslySetInnerHTML: {
      __html: "\n              window.dataLayer = window.dataLayer || [];\n              function gtag(){dataLayer.push(arguments);}\n              gtag('js', new Date());\n              \n              gtag('config', '".concat(googleAdwordsConfig, ", { allow_enhanced_conversions: true }')\n            ")
    }
  }) : null, googleAnalyticsId ? /*#__PURE__*/_react["default"].createElement(_script["default"], {
    id: "google-analytics-config",
    dangerouslySetInnerHTML: {
      __html: googleAnalyticsConfigScriptHTML
    }
  }) : null, !googleTagManager ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_script["default"], {
    id: "google-tag-manager",
    dangerouslySetInnerHTML: {
      __html: "\n                  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                  })(window,document,'script','dataLayer','".concat(googleTagManager, "');\n                ")
    }
  }), /*#__PURE__*/_react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("noscript", {
    dangerouslySetInnerHTML: {
      __html: "\n                      <iframe\n                        src=\"https://www.googletagmanager.com/ns.html?id=".concat(googleTagManager, "\"\n                        height=\"0\"\n                        width=\"0\"\n                        style=\"display:none;visibility:hidden\"\n                      />\n                    ")
    }
  }))));
});

exports["default"] = _default;